import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import TypewriterInput from "../components/TypewriterInput";
import Logo from "../components/Logo";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: top;
  min-height: 100vh;
  padding: 2rem;
`;

const SearchSection = styled.div`
  margin: 2rem 2rem;
  text-align: center;
`;

const SearchPrefix = styled.span`
  font-size: 2rem;
  font-weight: bold;
  margin-right: 0.5rem;
`;

const ValidateButton = styled.button`
  padding: 1rem 2rem;
  font-size: 1.2rem;
  background-color: #ff734f;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: #ff734f;
  }
`;

const Presentation = styled.p`
  font-size: 1.2rem;
  margin-bottom: 2rem;
  max-width: 700px;
  line-height: 1.8;
  text-align: center;
  color: #6e6e6e;
  margin-top: 2rem;
`;

const LandingPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = React.useState<string>("");

  const handleSubmit = () => {
    if (searchValue.trim()) {
      navigate("/email", { state: { searchValue } });
    }
  };

  return (
    <Container>
      <Logo />
      <Presentation>
        Parabole vous offre gratuitement une newsletter hebdomadaire entièrement
        personnalisée sur un sujet de votre choix.{" "}
      </Presentation>

      <SearchSection>
        <SearchPrefix>
          Suivre les activités du parlement qui concernent
        </SearchPrefix>
        <TypewriterInput
          value={searchValue}
          onChange={setSearchValue}
          examples={[
            "l'intelligence artificielle",
            "les assurances",
            "le harcèlement",
            "les aides aux entreprises",
            "la rénovation énergétique",
            "les énergies renouvelables",
            "la sécurité",
            "la santé",
            "l'éducation",
            "la justice",
          ]}
        />
      </SearchSection>

      <ValidateButton onClick={handleSubmit}>Valider</ValidateButton>
    </Container>
  );
};

export default LandingPage;
